import slugifyLib from 'slugify';

// this to mitigate the issue with HMR
export const slugify = slugifyLib;
